import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CustomFormControl} from '../controls/CustomFormControl';
import {UntypedFormArray, UntypedFormGroup} from '@angular/forms';
import {FormHelperService} from '../../services/form-helper.service';
import {FormElement} from '../../models/WebFormTemplate';
import {CustomFormGroup} from '../controls/CustomFormGroup';
import {Subscription} from 'rxjs';
import {FileOnlineViewModel} from '../../FileOnlineViewModel';

@Component({
  selector: 'app-form-template-array',
  templateUrl: './form-template-array.component.html',
  styleUrls: ['./form-template-array.component.scss']
})
export class FormTemplateArrayComponent implements OnInit, OnDestroy {

  @Input() control: CustomFormControl;
  @Input() formGroup: UntypedFormGroup;
  @Input() templates: Map<string, FormElement[]>;
  @Input() viewModel: FileOnlineViewModel;
  @Input() controls = new Map<string, CustomFormControl>();

  private addressLookupSubscription: Subscription;

  constructor(private formHelper: FormHelperService,
              private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.control.element.subscriptionType === 'address_lookup') {
      this.addressLookupSubscription = this.formHelper.addressLookupObservable.subscribe((group: UntypedFormGroup) => {
        this.addTemplateFormGroupItem(group);
      });
    }
  }

  ngOnDestroy(): void {
    this.addressLookupSubscription?.unsubscribe();
  }

  get formArray(): UntypedFormArray {
    return this.formGroup.get(this.formHelper.getFormArrayName(this.control.element.id)) as UntypedFormArray;
  }

  get templateFormGroups(): CustomFormGroup[] {
    return this.formArray.controls as CustomFormGroup[];
  }

  getFormArrayName(id: string): string {
    return this.formHelper.getFormArrayName(id);
  }

  getFormArray(id: string): UntypedFormArray {
    return this.formGroup.get(this.formHelper.getFormArrayName(id)) as UntypedFormArray;
  }

  onArrayDelete(control: CustomFormControl, i: number): void {
    const formArray = this.getFormArray(control.element.id);
    const formGroup = formArray.at(i) as CustomFormGroup;
    formArray.removeAt(i);
    this.cd.detectChanges();
    this.formHelper.handleArrayDelete(formGroup, this.viewModel);
  }

  isArrayFull(customControl: CustomFormControl): boolean {
    const formElement = customControl.element;
    const formArray = this.getFormArray(formElement.id);
    return 1 + formArray.length > formElement.maximum;
  }

  addTemplateFormGroupItem(group: UntypedFormGroup): void {
    const formArray = this.getFormArray(this.control.element.id);
    if (1 + formArray.length > this.control.element.maximum) {
      return;
    }

    formArray.push(group);
    this.cd.detectChanges();
  }

  addTemplateItem(customControl: CustomFormControl): void {
    const template = this.templates.get(customControl.element.id);
    const formArray = this.getFormArray(customControl.element.id);
    formArray.push(this.formHelper.buildFormGroupControlsForTemplate(template, this.templates, this.controls,
      this.viewModel, this.formGroup));
    this.cd.detectChanges();
  }

  trackIndex(index: number): number {
    return index;
  }
}
